import { useTranslation } from 'react-i18next';

/**
 * Board bar for people outside the organization: the board and who they are, no way into the dashboard. A guest cannot
 * turn into an account by themselves (P17, sign-ups are closed): they are told the studio can invite them instead.
 */
export function GuestBar({ title, name }: { title: string; name: string }) {
  const { t } = useTranslation();
  return (
    <div data-testid="guest-bar" className="flex flex-wrap items-center gap-x-3 gap-y-1">
      <span className="font-display font-bold">{title}</span>
      {name && <span className="font-sans text-sm text-fg-muted">{name}</span>}
      <span className="font-sans text-xs text-fg-muted">{t('guest.inviteHint')}</span>
    </div>
  );
}
